import { COLLECT_HOME_URL, COMPLY_HOME_URL } from "@/utils/const";
import { doesUserHaveScope } from "@/utils/doesUserHaveScope";

const getCorrectHomepage = (scopes?: IUserScope[]) =>
  doesUserHaveScope("LIST_CONTACTS", scopes)
    ? COLLECT_HOME_URL
    : COMPLY_HOME_URL;

export default getCorrectHomepage;
